// extracted by mini-css-extract-plugin
var _1 = "SearchPlatformMenuItem-module__addedIcon--ASCug";
var _2 = "SearchPlatformMenuItem-module__addedIconContainer--iCqEk";
var _3 = "SearchPlatformMenuItem-module__animateUploadProgressBarWidth--n1W63";
var _4 = "SearchPlatformMenuItem-module__animatedBackground--glUzA";
var _5 = "SearchPlatformMenuItem-module__authorized--cru3u";
var _6 = "SearchPlatformMenuItem-module__clearIcon--QH96v";
var _7 = "SearchPlatformMenuItem-module__container--iqGJn";
var _8 = "SearchPlatformMenuItem-module__content--dgkNm";
var _9 = "SearchPlatformMenuItem-module__logo--PqCG8";
var _a = "SearchPlatformMenuItem-module__name--ftJwR";
var _b = "SearchPlatformMenuItem-module__platformModes--JzeB3";
export { _1 as "addedIcon", _2 as "addedIconContainer", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "authorized", _6 as "clearIcon", _7 as "container", _8 as "content", _9 as "logo", _a as "name", _b as "platformModes" }
